import { render, staticRenderFns } from "./formB.vue?vue&type=template&id=07725968&"
import script from "./formB.vue?vue&type=script&lang=js&"
export * from "./formB.vue?vue&type=script&lang=js&"
import style0 from "./formB.vue?vue&type=style&index=0&id=07725968&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports